var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-button',{on:{"click":_vm.logout}},[_vm._v(" "+_vm._s(_vm.$t('ACCOUNT_PROBLEMS.LOGOUT'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }